var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDaruma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F75534"
    },
    d: "M482.358,294.661C482.358,436.046,381.015,512,256,512S29.642,436.046,29.642,294.661 S103.261,0,256,0S482.358,153.276,482.358,294.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD391E"
    },
    d: "M48.685,294.661c0-138.41,70.567-288.192,216.836-294.434C262.378,0.093,259.213,0,256,0 C103.261,0,29.642,153.276,29.642,294.661S130.986,512,256,512c3.191,0,6.362-0.063,9.521-0.161 C144.925,508.067,48.685,432.437,48.685,294.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE8D1"
    },
    d: "M430.387,251.235c-6.586,86.685-100.729,61.494-174.382,60.621 c-73.663,0.874-167.796,26.064-174.392-60.621c-2.996-39.367,2.764-70.521,9.944-92.804c7.849-24.358,30.672-40.755,56.263-40.755 H364.18c25.591,0,48.413,16.398,56.263,40.755C427.623,180.715,433.383,211.869,430.387,251.235z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC7A4"
    },
    d: "M100.476,251.235c-2.996-39.367,2.764-70.521,9.944-92.804 c7.849-24.358,30.672-40.755,56.263-40.755H147.82c-25.591,0-48.413,16.398-56.263,40.755c-7.181,22.282-12.94,53.436-9.944,92.804 c4.421,58.096,48.162,65.939,98.707,64.533C138.163,314.367,104.335,301.951,100.476,251.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC7A4"
    },
    d: "M274.869,311.856c-3.11,0.037-6.258,0.12-9.432,0.233c28.025,1,58.256,4.571,85.112,3.678 C325.677,315.075,299.158,312.144,274.869,311.856z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7EDE3"
    },
    cx: 167.675,
    cy: 256.836,
    r: 35.279
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7EDE3"
    },
    cx: 344.325,
    cy: 256.836,
    r: 35.279
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#362928"
    },
    d: "M262.582,197.752c0,0,32.123-1.309,76.523-48.786c0,0,10.891-18.726,29.238-3.009 c11.306,9.684,13.575,28.841-21.378,51.388C290.709,233.632,262.582,197.752,262.582,197.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#362928"
    },
    d: "M249.418,197.752c0,0-32.123-1.309-76.523-48.786c0,0-10.891-18.726-29.238-3.009 c-11.306,9.684-13.575,28.841,21.378,51.388C221.291,233.632,249.418,197.752,249.418,197.752z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE666"
    },
    d: "M242.942,488.831c0,0-24.763-28.444-31.186-122.62c0,0,2.735-31.605-21.432-28.073 c-14.892,2.177-28.361,23.291-14.276,79.614C198.717,508.404,242.942,488.831,242.942,488.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE666"
    },
    d: "M151.181,454.513c0,0-20.547-23.602-25.877-101.745c0,0,2.27-26.225-17.783-23.294 c-12.357,1.806-23.533,19.325-11.846,66.061C114.484,470.754,151.181,454.513,151.181,454.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE666"
    },
    d: "M269.058,488.831c0,0,24.763-28.444,31.186-122.62c0,0-2.735-31.605,21.432-28.073 c14.892,2.177,28.361,23.291,14.276,79.614C313.283,508.404,269.058,488.831,269.058,488.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE666"
    },
    d: "M360.819,454.513c0,0,20.547-23.602,25.877-101.745c0,0-2.27-26.225,17.783-23.294 c12.357,1.806,23.533,19.325,11.846,66.061C397.516,470.754,360.819,454.513,360.819,454.513z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#362928"
    },
    d: "M299.379,144.438C277.689,168.011,256,174.35,256,174.35s-21.689-6.338-43.379-29.911 c0,0,22.151-4.765,43.379-4.765C277.228,139.674,299.379,144.438,299.379,144.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#362928"
    },
    d: "M167.676,300.199c-23.91,0-43.363-19.453-43.363-43.363c0-23.91,19.453-43.363,43.363-43.363 s43.363,19.453,43.363,43.363C211.039,280.746,191.586,300.199,167.676,300.199z M167.676,229.641 c-14.994,0-27.195,12.199-27.195,27.195s12.2,27.194,27.195,27.194s27.195-12.199,27.195-27.194S182.67,229.641,167.676,229.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#362928"
    },
    d: "M344.324,300.199c-23.91,0-43.363-19.453-43.363-43.363c0-23.91,19.453-43.363,43.363-43.363 s43.363,19.453,43.363,43.363C387.687,280.746,368.235,300.199,344.324,300.199z M344.324,229.641 c-14.994,0-27.195,12.199-27.195,27.195s12.2,27.194,27.195,27.194s27.195-12.199,27.195-27.194S359.318,229.641,344.324,229.641z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#362928"
    },
    cx: 388.723,
    cy: 203.389,
    r: 8.084
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#362928"
    },
    cx: 405.577,
    cy: 235.144,
    r: 8.084
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#362928"
    },
    cx: 123.277,
    cy: 203.389,
    r: 8.084
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#362928"
    },
    cx: 106.423,
    cy: 235.144,
    r: 8.084
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaruma);
export default __webpack_public_path__ + "static/media/daruma.114888922fea6366f596f9052807fffc.svg";
export { ForwardRef as ReactComponent };